import $ from "jquery";
import Foundation from "./3rd/_zf";
import select2 from "select2";

select2();

import BackToTop from "./components/back-to-top";
import lazyLoader from "./components/lazy-loader";
import { initSocialShare } from "./components/social-share";
import SimpleBar from "simplebar";
import ResizeObserver from "resize-observer-polyfill";
import { Fancybox } from "@fancyapps/ui";

window.ResizeObserver = ResizeObserver;

// Styles
import "../sass/components/_awesome_font.scss";
import "../sass/3rd/_zf.scss";
import "simplebar/dist/simplebar.css";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Global variables

// const {
//     _ajaxUrl: ajaxUrl,
//     _baseUrl: baseUrl,
//     _themeUrl: themeUrl,
//     _csrfToken: csrfToken,
//     _restToken: restToken,
//     _lang: lang,
// } = {...hdDefaults, ...(typeof hd !== 'undefined' ? hd : {})};

// Document ready
document.addEventListener("DOMContentLoaded", () => {
  init();
  remove_token_param();

  // menu
  const container = document.querySelector("nav.nav");
  const menu = document.querySelector(".main-nav");

  function adjustMenu() {
    let more = menu.querySelector(".more");

    if (!more) {
      more = document.createElement("li");
      more.classList.add("menu-item", "more");
      more.innerHTML = '<a href="#"></a><ul class="sub-menu dropdown"></ul>';
      menu.appendChild(more);
    }

    const dropdown = more.querySelector(".dropdown");
    dropdown.innerHTML = "";
    more.style.display = "none";

    let items = [...menu.children].filter((li) => li !== more);
    items.forEach((li) => (li.style.display = "block"));

    if (menu.scrollWidth <= container.clientWidth) {
      removeOverflowHidden();
      return;
    }

    let hiddenItems = [];
    for (let i = items.length - 1; i >= 0; i--) {
      if (menu.scrollWidth > container.clientWidth) {
        hiddenItems.unshift(items[i]);
        items[i].style.display = "none";
      } else {
        break;
      }
    }

    if (hiddenItems.length > 0) {
      hiddenItems.forEach((item) => {
        let clone = item.cloneNode(true);
        clone.style.display = "block";
        dropdown.appendChild(clone);
      });
      more.style.display = "block";
    }

    removeOverflowHidden();
  }

  function setOverflowHidden() {
    container.style.overflow = "hidden";
  }

  function removeOverflowHidden() {
    container.style.overflow = "visible";
  }

  function reinitializeFoundationDropdown() {
    if (typeof Foundation !== "undefined") {
      let mainNav = $("ul.main-nav");
      if (mainNav.length) {
        new Foundation.DropdownMenu(mainNav);
      }
    }
  }

  let resizeTimeout;
  window.addEventListener("resize", function () {
    setOverflowHidden();
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      adjustMenu();
      reinitializeFoundationDropdown();
    }, 100);
  });

  adjustMenu();

  // _blank
  document.querySelectorAll('a._blank, a.blank, a[target="_blank"]').forEach((el) => {
    if (!el.hasAttribute('target') || el.getAttribute('target') !== '_blank') {
      el.setAttribute('target', '_blank');
    }

    let rel = el.getAttribute('rel') || '';
    let rels = rel.split(' ').map(r => r.trim()).filter(Boolean);

    // Always add noopener & noreferrer for target="_blank"
    if (!rels.includes('noopener')) rels.push('noopener');
    if (!rels.includes('noreferrer')) rels.push('noreferrer');

    // Remove nofollow (dofollow by default)
    rels = rels.filter(r => r !== 'nofollow');

    if (rels.length > 0) {
      el.setAttribute('rel', rels.join(' '));
    }
  });

  // fancybox popup
  $(".fcy_popup").on("click", function (e) {
    e.preventDefault();
    Fancybox.show([{ src: "#form_popup", type: "inline" }]);
  });

  // toggle menu footer
  document.querySelectorAll(".site-footer .footer-title").forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      this.classList.toggle("active");
    });
  });

  // region branch
  document
    .querySelector("#branch-region")
    ?.addEventListener("change", function (event) {
      event.preventDefault();
      let id = this.value;

      let branch_list_nav = $(".branch-list-nav");
      let branch_map = $("#branch-map");
      let num_title = $("#num-title");

      branch_list_nav.addClass("ajax-loading");
      branch_map.addClass("ajax-loading");

      $.ajax({
        type: "POST",
        url: ajaxUrl,
        data: {
          action: "change_region_select",
          data: { id: id },
          _wpnonce: csrfToken,
        },
      })
        .done(function (result) {
          if (result.success === true) {
            branch_list_nav.html(result.data.ul_html);
            branch_map.html(result.data.iframe_html);
            num_title.html(result.data.post_count);

            if (branch_list_nav[0].SimpleBar) {
              branch_list_nav[0].SimpleBar.unMount();
            }

            branch_list_nav[0].SimpleBar = new SimpleBar(branch_list_nav[0], {
              autoHide: true,
            });
          }
        })
        .always(function () {
          branch_list_nav.removeClass("ajax-loading");
          branch_map.removeClass("ajax-loading");
        });
    });

  // branch-list-nav
  //  Event Delegation
  document.addEventListener("click", function (e) {
    if (e.target.closest(".branch-item")) {
      e.preventDefault();

      const branchItem = e.target.closest(".branch-item");
      const branchId = branchItem.dataset.id;

      let branch_map = $("#branch-map");
      branch_map.addClass("ajax-loading");

      $.ajax({
        type: "POST",
        url: ajaxUrl,
        data: {
          action: "get_iframe_map",
          data: { id: branchId },
          _wpnonce: csrfToken,
        },
      })
        .done(function (result) {
          if (result.success === true) {
            branch_map.html(result.data.iframe_html);
          }
        })
        .always(function () {
          branch_map.removeClass("ajax-loading");
        });
    }
  });

  const observer = new MutationObserver(() => {
    document.querySelectorAll('ul.sub-menu[role="menubar"]').forEach((menu) => {
      menu.setAttribute("role", "menu");
    });

    document
      .querySelectorAll('[aria-hidden="true"] a, [aria-hidden="true"] button')
      .forEach((el) => {
        el.setAttribute("tabindex", "-1");
      });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Initialize
function init() {
  // Sticky header
  const menuHeader = document.querySelector("#menu-header");
  if (menuHeader) {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        menuHeader.classList.add("is-sticky");
      } else {
        menuHeader.classList.remove("is-sticky");
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
  }

  new BackToTop();
  lazyLoader(4000, "script[data-type='lazy']");
  initSocialShare("[data-social-share]", {
    intents: ["facebook", "x", "print", "send-email", "web-share"],
  });

  // select2 switcher language
  const pll = $(".site-header .pll-switcher-select");
  if (pll.length > 0) {
    pll.select2({
      minimumResultsForSearch: -1,
      width: "resolve",
      dropdownAutoWidth: true,
      dropdownParent: pll.closest(".cell-hotline"),
    });

    pll.on("select2:select", function (e) {
      window.location.href = e.params.data.id;
    });
  }

  // Counter
  // https://stackoverflow.com/questions/68605784/animated-counter-when-scrolling-into-viewport-with-thousands-separator
  const animNum = (EL) => {
    if (EL._isAnimated) return; // Animate only once!
    EL._isAnimated = true;

    $(EL)
      .prop("Counter", 0)
      .animate(
        {
          Counter: EL.dataset.counter,
        },
        {
          duration: 5000,
          easing: "linear",
          step: function (now) {
            const text = Math.ceil(now).toLocaleString("en-US");
            const html = text
              .split(",")
              .map((n) => `<span class="count">${n}</span>`)
              .join(",");
            $(this).html(html);
          },
        },
      );
  };

  const inViewport = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) animNum(entry.target);
    });
  };

  $("[data-counter]").each((i, EL) => {
    const observer = new IntersectionObserver(inViewport);
    observer.observe(EL);
  });

  // Tabs
  const tabContainers = document.querySelectorAll(".filter-tabs");
  if (!tabContainers.length) return;
  tabContainers.forEach((tabContainer) => {
    const tabs = tabContainer.querySelectorAll(".tabs-nav a");
    const panels = tabContainer.querySelectorAll(".tabs-panel");

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href").replace("#", "");
        const targetPanel = tabContainer.querySelector(`#${targetId}`);

        if (!targetPanel) return;

        tabs.forEach((t) => t.classList.remove("current"));
        panels.forEach((panel) => panel.classList.remove("active"));

        this.classList.add("current");
        targetPanel.classList.add("active");
      });
    });
  });
}

/**
 * @private
 */
function remove_token_param() {
  let url = new URL(window.location.href);
  let changed = false;

  if (url.searchParams.has("_csrf_token")) {
    url.searchParams.delete("_csrf_token");
    changed = true;
  }

  if (url.searchParams.has("_wpnonce")) {
    url.searchParams.delete("_wpnonce");
    changed = true;
  }

  if (changed) {
    window.history.replaceState(null, "", url.toString());
  }
}
